import React from "react";
import { MimaText } from "../../../components";
import { amountFormatter } from "../../../utils/utils";
const P2PSellerInfo = ({ singleItem }) => {
  const seller = singleItem?.seller;
  const sellerFullname = `${seller?.firstname} ${seller?.lastname}`;
  const sellerDebitValue = singleItem.sellerDebitValue;
  const sellerCreditValue = singleItem.sellerCreditValue;
  const sellerStatus = singleItem.sellerStatus;
  const sellerForeignAccount = singleItem.sellerBankInfo.foreign.data;
  const adminSellerPaymentStatus = singleItem.adminSellerPaymentStatus;

  return (
    <>
      <MimaText variant="subtitleBold" mb={2} align="center">
        Seller Info
      </MimaText>
      <div className="modal__beside__grid">
        <MimaText labelTitle="Seller Name">{sellerFullname}</MimaText>
        <MimaText labelTitle="Seller Username">{seller?.username}</MimaText>
        <MimaText labelTitle="Seller Orders">{seller?.orders} orders</MimaText>

        <MimaText labelTitle="Seller Insurance Fee:">
          {amountFormatter(sellerDebitValue?.currencyCode).format(
            singleItem.sellerInsuranceFee
          )}
        </MimaText>
        <MimaText labelTitle="Seller Debit Value">
          {amountFormatter(sellerDebitValue?.currencyCode).format(
            sellerDebitValue?.amount
          )}
        </MimaText>
        <MimaText labelTitle="Seller Credit Value">
          {amountFormatter(sellerCreditValue?.currencyCode).format(
            sellerCreditValue?.amount
          )}
        </MimaText>
        <MimaText labelTitle="Seller Avg Comp. Rate">
          {seller?.avgCompletionRate} %
        </MimaText>
        <MimaText labelTitle="Seller Avg Comp. Time">
          {seller?.avgCompletionTime} mins
        </MimaText>
        <MimaText mb={1} labelTitle="Seller Payment Status">
          <div
            className={`status  ${sellerStatus === "PAID" ? "status__green" : sellerStatus === "VALIDATION" ? "status__blue" : sellerStatus === "REVERSED" ? "status__grey" : sellerStatus === "FALSE-PAYMENT" ? "status__red" : "status__dark__yellow"}`}
          >
            {sellerStatus}
          </div>
        </MimaText>
        <MimaText mb={1} labelTitle="Admin Seller Payment Status:">
          <div
            className={`status  ${adminSellerPaymentStatus === "PAID" ? "status__green" : adminSellerPaymentStatus === "REVERSED" || adminSellerPaymentStatus === "NO-RESPONSE-FROM-SELLER" ? "status__grey" : adminSellerPaymentStatus === "FAILED" ? "status__red" : "status__dark__yellow"}`}
          >
            {adminSellerPaymentStatus}
          </div>
        </MimaText>
      </div>
      <div>
        {sellerForeignAccount.length > 0 ? (
          <div>
            <MimaText variant="subtitleBold" mb={1} mt={2}>
              Seller Bank Info
            </MimaText>
            <MimaText mb={1} labelTitle="Payment Type">
              {singleItem.sellerBankInfo.foreign.paymentType}
            </MimaText>
            {singleItem.sellerBankInfo.foreign.data.map((x) => (
              <>
                <MimaText mb={1} labelTitle={x.label}>
                  {x.value}
                </MimaText>
              </>
            ))}
          </div>
        ) : (
          <div>
            <MimaText variant="subtitleBold" mb={1} mt={2}>
              Seller Bank Info
            </MimaText>

            <MimaText mb={1} labelTitle="Account Name:">
              {singleItem.sellerBankInfo.accountName}
            </MimaText>
            <MimaText mb={1} labelTitle="Account Number:">
              {singleItem.sellerBankInfo.accountNumber}
            </MimaText>

            <MimaText mb={1} labelTitle="Account Currency:">
              {singleItem.sellerBankInfo.currencyCode}
            </MimaText>

            <MimaText mb={1} labelTitle="Bank Name:">
              {singleItem.sellerBankInfo.bank}
            </MimaText>
          </div>
        )}

        {singleItem.sellerPaymentProofUrls.length > 0 && (
          <div>
            <MimaText variant="subtitleBold" mb={2} mt={2}>
              Seller Payment Proof to Admin
            </MimaText>
            {singleItem.sellerPaymentProofUrls.map((x, i) => (
              <div
                key={i}
                style={{
                  width: "100%",
                  paddingInline: "3rem",
                }}
              >
                <img src={x} alt="Payment Proof" width="100%" />
                <div>
                  <a href={x} download="file.jpg">
                    Download file
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}

        {singleItem.adminSellerPaymentProofUrls.length > 0 && (
          <div>
            <MimaText variant="subtitleBold" mb={2} mt={2}>
              Admin Payment Proof to Seller
            </MimaText>
            {singleItem.adminSellerPaymentProofUrls.map((x, i) => (
              <div
                key={i}
                style={{
                  width: "100%",
                  paddingInline: "3rem",
                }}
              >
                <img src={x} alt="Payment Proof" width="100%" />
                <div>
                  <a href={x} download="file.jpg">
                    Download file
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default P2PSellerInfo;
